export function calculateContainScale({
  containerWidth,
  containerHeight,
  artworkWidth,
  artworkHeight,
  maxScale = 1
}) {
  const values = [containerWidth, artworkWidth, artworkHeight, maxScale];

  if (values.some((value) => !Number.isFinite(value) || value <= 0)) return 0;

  const widthScale = containerWidth / artworkWidth;
  const heightScale = Number.isFinite(containerHeight) && containerHeight > 0
    ? containerHeight / artworkHeight
    : Infinity;
  const scale = Math.min(widthScale, heightScale, maxScale);

  return Number.isFinite(scale) && scale > 0 ? scale : 0;
}
